<template>
  <div>
    <BaseButton secondary on-dark @click="importContacts">
      {{ $t('accountContacts.importContacts') }}
    </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    importContacts() {
      this.$modal.show({
        component: () => import('@/components/Contacts/ImportContactsDialog.vue'),
        props: {
          accountId: this.accountId,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
